export function toTransparent(color: string, alpha = 0.15): string {
  const hex = color.startsWith('#') ? color.slice(1) : null;
  if (hex) {
    const parse = (h: string) => parseInt(h, 16);
    const r =
      hex.length === 3 ? parse(hex[0] + hex[0]) : parse(hex.slice(0, 2));
    const g =
      hex.length === 3 ? parse(hex[1] + hex[1]) : parse(hex.slice(2, 4));
    const b =
      hex.length === 3 ? parse(hex[2] + hex[2]) : parse(hex.slice(4, 6));
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  }

  if (color.startsWith('rgba'))
    return color.replace(/rgba\(([^)]+)\)/, (_m, body) => {
      const parts = body.split(',').map((s: any) => s.trim());
      return `rgba(${parts[0]}, ${parts[1]}, ${parts[2]}, ${alpha})`;
    });
  if (color.startsWith('rgb('))
    return color.replace('rgb(', 'rgba(').replace(')', `, ${alpha})`);
  return color;
}

export const PALETTE = [
  '#1f77b4', 
  '#ff7f0e', 
  '#2ca02c', 
  '#d62728', 
  '#9467bd', 
  '#8c564b',
  '#e377c2', 
  '#7f7f7f', 
  '#bcbd22', 
  '#17becf', 
];

export const SEVERITY_COLOR_MAP: Record<string, string> = {
  critical: '#ef4444',
  high: '#f97316',
  medium: '#eab308',
  low: '#34d399',
};

export function getSeverityColor(severity: string): string {
  return SEVERITY_COLOR_MAP[severity] || '#cccccc';
}